import Toolbar from './Toolbar';
import './toolbar.scss';

export default Toolbar;
